import Skeleton from '@pelckmans/elementis/components/skeleton';
import { useId } from 'react';

interface BaseProps {
  size?: number;
  height?: number;
}

interface OptionalAriaLabelProps extends BaseProps {
  isLoading?: false;
  'aria-label'?: string;
}

interface LoadingProps extends BaseProps {
  isLoading: true;
  'aria-label': string;
}

export type SkeletonListProps = OptionalAriaLabelProps | LoadingProps;

function ListSkeleton({ isLoading = false, size = 8, 'aria-label': ariaLabel, height = 48 }: SkeletonListProps) {
  const id = useId();

  return (
    <Skeleton className="skeleton" aria-label={ariaLabel} animate={isLoading}>
      {Object.keys(Array.from({ length: size })).map(key => (
        <Skeleton.Bone key={`${id}-${key}`} height={height} />
      ))}
    </Skeleton>
  );
}

export default ListSkeleton;
